export const detailUrl = ({ id }) => {
  return ``;
};
export const overviewUrl = () => {
  return ``;
};
